import type { MagentoShippingMethod } from "@jti/magento-types";

import { isDeliveryOptionSelectable } from "./prepareDeliveryOptions";

export const isDeliveryOptionsSelectionDisabled = (
  options: MagentoShippingMethod[],
  isSubscription?: boolean
): boolean => {
  const selectableOptionsCount = options.filter((option) => isDeliveryOptionSelectable(option, isSubscription)).length;

  return options.length === 1 || selectableOptionsCount === 0;
};
